// extracted by mini-css-extract-plugin
export default {"container":"collection-summary_container__S3mt1","image":"collection-summary_image__2LEBS","description":"collection-summary_description__NaLRX"};